// extracted by mini-css-extract-plugin
export var callToActionContainer = "Banner-module--call-to-action-container--8c55c";
export var container = "Banner-module--container--b6c78";
export var crossIcon = "Banner-module--cross-icon--7ebe1";
export var headerProfileContainer = "Banner-module--header-profile-container--a8bad";
export var headerSearchContainer = "Banner-module--header-search-container--a8972";
export var homepageText = "Banner-module--homepage-text--26a32";
export var logoLinkContainer = "Banner-module--logo-link-container--4902d";
export var mainHeader = "Banner-module--main-header--de30b";
export var messageContainer = "Banner-module--message-container--4621c";
export var profilePlaceholder = "Banner-module--profile-placeholder--c7ffa";
export var title = "Banner-module--title--08ca5";
export var titleContainer = "Banner-module--title-container--2a860";
export var wrapper = "Banner-module--wrapper--be6fa";